<template>
  <section v-if="refundOrderItems.length">
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-min no-br">{{ "index" | translate }}</th>
          <th>{{ "vendor" | translate }}</th>
          <th class="no-br">{{ "order_num" | translate }}</th>
          <th class="no-br">{{ "quantity" | translate }}</th>
          <th>{{ "amount" | translate }}</th>
          <th>{{ "refunds" | translate }}</th>
          <th>{{ "comment" | translate }}</th>
          <th v-no-print v-if="!readonly">@</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="'item' + index" v-for="(item, index) in refundOrderItems">
          <td>{{ index + 1 }}</td>
          <td class="w-10">{{ item.vendor }}</td>
          <td class="w-15">
            <span class="bg-warning">{{ item.refundOrderNumber }}</span>
            {{ item.orderNumber }}
          </td>
          <td class="w-5">{{ item.quantity }}</td>
          <td class="w-10">
            {{ item.amount | number(2) }} {{ item.currency | translate }}
          </td>
          <td>
            <part-transaction-list-present
              :transactions="item.refunds"
            ></part-transaction-list-present>
          </td>
          <td class="w-15">{{ item.comment }}</td>
          <td class="w-min no-br" v-no-print v-if="!readonly">
            <a
              class="mr-1"
              href="javascript:void(0)"
              @click="editRefundOrderItem(item)"
              >{{ "edit" | translate }}</a
            >
            <a href="javascript:void(0)" @click="remove(index)">{{
              "remove" | translate
            }}</a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">{{ "total" | translate }}</th>
          <th>{{ totalQuantity }}</th>
          <th colspan="3" class="text-right">
            <div v-for="(total, index) in totalAmountList" :key="'t' + index">
              {{ total.total | number(2) }} {{ total.currency | translate }}
            </div>
          </th>
          <th v-no-print v-if="!readonly"></th>
        </tr>
      </tfoot>
    </table>
  </section>
</template>

<script>
import { ModalService } from "@/modules/xs-modal";
import ModalRefundOrderItemForm from "./ModalRefundOrderItemForm";
import PartTransactionListPresent from "./PartTransactionListPresent";
import _ from "lodash";

export default {
  props: ["refundOrderItems", "readonly"],
  data() {
    return {};
  },
  computed: {
    totalQuantity() {
      return this.refundOrderItems.reduce((sum, item) => {
        if (item.quantity) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);
    },
    totalAmountList() {
      let currencyList = [
        ...new Set(
          this.refundOrderItems.map(item => item.currency).filter(cur => cur)
        )
      ];

      return currencyList.map(curr => {
        return {
          currency: curr,
          total: this.refundOrderItems.reduce((sum, item) => {
            if (item.quantity && item.currency === curr) {
              return sum + item.amount;
            }
            return sum;
          }, 0)
        };
      });
    }
  },
  methods: {
    editRefundOrderItem(item) {
      ModalService.open(ModalRefundOrderItemForm, {
        editingItem: item
      }).then(refundOrderItem => {
        _.assign(item, refundOrderItem);
        this.$emit("update");
      });
    },
    remove(index) {
      this.refundOrderItems.splice(index, 1);
      this.$emit("update");
    }
  },
  components: {
    PartTransactionListPresent
  }
};
</script>
